import { render, staticRenderFns } from "./appBlack.vue?vue&type=template&id=4a36b750&scoped=true&"
import script from "./appBlack.vue?vue&type=script&lang=js&"
export * from "./appBlack.vue?vue&type=script&lang=js&"
import style0 from "./appBlack.vue?vue&type=style&index=0&id=4a36b750&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a36b750",
  null
  
)

export default component.exports